export default "__VITE_ASSET__DML1v1rH__"